import { useEffect, useState } from 'react';
import {
  Checkbox,
  IconFilterCircle,
  CheckboxFilter,
  ButtonPrimary,
  ButtonSize,
  IconSorting,
} from '@ui/src';
import { DocumentRowHeaderTypes } from '../types';
import { CustomerStatus } from '../../../../hoc/common/types';

import cn from '../styles.module.css';

const DocumentsRowHeader = ({
  type,
  onGroupSelect,
  onGroupByIdSelect,
  documents,
  documentsSelected,
  depricated,
  total,
  setSelectedStatuses,
  selectedStatuses,
  sort,
  onChangeSort,
  sortProp,
  status,
}: DocumentRowHeaderTypes) => {
  const [menuVisible, setMenuVisible] = useState(false);
  const [statuses, setStatuses] = useState<string[]>([]);

  useEffect(() => {
    setStatuses(selectedStatuses as string[]);
  }, [selectedStatuses]);

  return (
    <div className={cn.documentsRowHeader}>
      <div className={cn.documentsRowHeaderLeft}>
        <div className={cn.documentRowHeaderLeftContent}>
          <div
            className={`${cn.documentsRowHeaderLeftItem} ${
              cn.documentsRowHeaderLeftItemFlex
            } ${sort === 'asc' ? cn.sortAsc : cn.sortDesc}`}
          >
            <Checkbox
              name={`checkbox-${type}`}
              title=""
              onChange={(e) => {
                if (depricated) {
                  onGroupSelect({
                    type,
                    selected: e.target.checked,
                  });
                } else {
                  onGroupByIdSelect({
                    id: type,
                    selected: e.target.checked,
                  });
                }
              }}
              type="checkbox"
              checked={documentsSelected === total}
              visualClassName={cn.selectGroupDocumentsVisual}
              disabled={!documents?.length || status === CustomerStatus.CLOSED}
            />
            <button
              type="button"
              onClick={() =>
                onChangeSort(sort === 'asc' ? 'desc' : 'asc', 'createdAt')
              }
              className={cn.sortButton}
            >
              <div className={cn.rowText}>Creation date</div>
              {sortProp === 'createdAt' && (
                <div className={cn.sortIcon}>
                  <IconSorting />
                </div>
              )}
            </button>
          </div>
          <div
            className={`${cn.documentsRowHeaderLeftItem} ${
              sort === 'asc' ? cn.sortAsc : cn.sortDesc
            }`}
          >
            <button
              type="button"
              onClick={() =>
                onChangeSort(sort === 'asc' ? 'desc' : 'asc', 'name')
              }
              className={cn.sortButton}
            >
              <div className={cn.rowText}>Name</div>

              {sortProp === 'name' && (
                <div className={cn.sortIcon}>
                  <IconSorting />
                </div>
              )}
            </button>
          </div>
        </div>
      </div>
      <div className={cn.documentsRowHeaderRight}>
        <div className={cn.documentsRowHeaderRightContentLeft}>
          <div
            className={`${cn.documentsRowHeaderRightItem} ${
              sort === 'asc' ? cn.sortAsc : cn.sortDesc
            }`}
          >
            <button
              type="button"
              onClick={() =>
                onChangeSort(sort === 'asc' ? 'desc' : 'asc', 'expirationDate')
              }
              className={cn.sortButton}
            >
              <div className={cn.rowText}>Exp.Date</div>

              {sortProp === 'expirationDate' && (
                <div className={cn.sortIcon}>
                  <IconSorting />
                </div>
              )}
            </button>
          </div>
          <div
            className={`${cn.documentsRowHeaderRightItem} ${cn.documentRowHeaderRightItemStatus}`}
          >
            <button
              type="button"
              aria-label="Filter Button"
              className={`${cn.statusFilter} ${
                menuVisible ? cn.menuVisible : ''
              }  ${
                !menuVisible && selectedStatuses && selectedStatuses?.length
                  ? cn.active
                  : ''
              }`}
              onClick={() => setMenuVisible(!menuVisible)}
            >
              <div className={cn.iconWrapper}>
                <IconFilterCircle />
              </div>
              <div className={cn.buttonText}>Status</div>
            </button>
            {menuVisible && (
              <div
                className={`${cn.statusFilterModal} ${
                  menuVisible ? cn.visible : ''
                }`}
              >
                <CheckboxFilter
                  name="status"
                  fields={[
                    {
                      name: 'New',
                      value: 'NEW',
                      title: 'New',
                    },
                    {
                      name: 'Accepted',
                      value: 'ACCEPTED',
                      title: 'Accepted',
                    },
                    {
                      name: 'Rejected',
                      value: 'REJECTED',
                      title: 'Rejected',
                    },
                    {
                      name: 'Expired',
                      value: 'EXPIRED',
                      title: 'Expired',
                    },
                  ]}
                  type="checkbox"
                  values={{ value: statuses || [] }}
                  onChange={(data) => setStatuses(data)}
                />
                <div className={cn.statusFilterSubmitWrapper}>
                  <ButtonPrimary
                    size={ButtonSize.SMALL}
                    text="Apply"
                    onClick={() => {
                      setSelectedStatuses(statuses);
                      setMenuVisible(false);
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DocumentsRowHeader;
